import { getDataBase } from '../db';

 
export default class AnormalidadCorrectaBLL {

    cError = "";

//RESUELTO
    async EsInstalacionNueva(GeneracionFactura, MedidorAnormalidad, Cliente, tcCobro, DataBaseAlias, CantidadHistorico) {
        let lnResult = '';
        let llEsNuevaIns = false;
        let lnCantidadLecturas = -1;
        this.cError = "";
        let llTieneUnicoInstalam = false;
    
        try {
     
          
          //RESUELTO
          const loParametroLectura = await this.GetAllParametroLectura(1);

          const MesesNuevo = loParametroLectura[0].MesesNuevo;
          const ID_Nuevo = loParametroLectura[0].AnormalidadNuevo;
    
 //RESUELTO
          llTieneUnicoInstalam = await this.TieneUnicoInstalam(GeneracionFactura, Cliente, DataBaseAlias);
      //RESUELTO
          lnCantidadLecturas = await this.CantidadLecturas(tcCobro, Cliente, DataBaseAlias, CantidadHistorico);
    
          if (lnCantidadLecturas >= 0) {
            if (lnCantidadLecturas <= MesesNuevo) {
              llEsNuevaIns = true; // obtener desde ParametroLectura - MesesNuevo
            }
            if (!llEsNuevaIns) {
              llEsNuevaIns = llTieneUnicoInstalam;
            }
          } else {
            this.cError = "Error al Consultar Cantidad";
          }
    
          if (ID_Nuevo > 0) { // obtener desde ParametroLectura - AnormalidadNuevo > 0
            if (ID_Nuevo == MedidorAnormalidad) { // obtener desde ParametroLectura - AnormalidadNuevo > 0
              lnResult = 0;
              if (!llEsNuevaIns) {
                lnResult = 2;
                this.cError = "[Error][No Tiene Instalación Nueva el Asociado]";
              }
            } else {
              if (llEsNuevaIns) {
                lnResult = 1;
                this.cError = "[Error][Tiene Instalación Nueva el Asociado]";
              } else {
                lnResult = 2; // Ignorar en las siguientes invocaciones.
              }
            }
          } else {
            lnResult = 3; // Ignorar en las siguientes invocaciones.
            this.cError = "[Informativo] Instalación Nueva no tiene Valor en ParaLect";
          }
        } catch (error) {
          const lcLog = "  ProcedureInitial: GenLect.EsInstalacionNueva() ";
          this.cError = "Error Try/Catch";
          console.error(this.cError, lcLog, error);
        }
    
        return lnResult;
      }

      //RESUELTO
    async TieneUnicoInstalam(GeneracionFactura, Cliente, DataBaseAlias) {
      let llResult = 0;

      try {
        // Obtener los parámetros de lectura
        const loParametroLectura = await this.GetAllParametroLectura(1);
    
        // Obtener los datos de la generación de factura
        const loGeneracionFactura = await this.GetAllGeneracionFactura(GeneracionFactura);
        

        const FechaGeneracionLectura = new Date(loGeneracionFactura[0].FechaGeneracionLectura);

        // Calcular las fechas de inicio y fin
        const FechaInicio = new Date(FechaGeneracionLectura);
        FechaInicio.setDate(FechaInicio.getDate() - loParametroLectura[0].DiasDeInstalacion);

        const FechaFin = new Date(FechaGeneracionLectura);
        FechaFin.setDate(FechaFin.getDate() - 31);

        // Formatear zona y ruta
        const zona = loGeneracionFactura[0].Zona < 10 ? '0' + loGeneracionFactura[0].Zona : loGeneracionFactura[0].Zona;
        const ruta = loGeneracionFactura[0].Ruta < 10 ? '0' + loGeneracionFactura[0].Ruta : loGeneracionFactura[0].Ruta;
        const ZonaRuta = zona + ruta;
       
        // Verificar instalación nueva
        // const loInstalacionNuevaDAL = new InstalacionMedidorDAL();
        // const loInstalacionNueva = await loInstalacionNuevaDAL.instalacionNueva(FechaInicio.toISOString(), FechaFin.toISOString(), ZonaRuta, DataBaseAlias);
        const loInstalacionNueva = [];
        // loInstalacionNueva.push({
        //     NuevaInstalacion: 1
        // });


        if (loInstalacionNueva.length > 0) {
          if (loInstalacionNueva[0].NuevaInstalacion == 1) {
            llResult = 1;
          }
        }
      } catch (error) {
        const lcLog = "ProcedureInitial: AnormalidadCorrectaBLL.TieneUnicoInstalam()";
        this.cError = "Error Try/Catch";
        console.error(this.cError, lcLog, error);
      }

      return llResult;
    }
  
    //RESUELTO
    async CantidadLecturas(tcCobro, Cliente, DataBaseAlias, tnCantidadHistorico) {
      let lnResult = 0;
  
      try {
      
        // TODO by Cristian, se trajo tnCantidadHistorico desde oClienteDatos
        const loHistoricoFactura = [];
        loHistoricoFactura.push({
            Cantidad: tnCantidadHistorico
        });

        if (loHistoricoFactura.length > 0) {
          lnResult = loHistoricoFactura[0].Cantidad; // Obtener la cantidad desde la tabla HistoricoFactura
        }
      } catch (error) {
        lnResult = -1;
        const lcLog = "ProcedureInitial: GenLect.CantidadLecturas()";
        this.cError = "Error Try/Catch";
        console.error(this.cError, lcLog, error);
      }
  
      return lnResult;
    }

     //RESUELTO
    async EsCambioDeMedidor(GeneracionFactura, MedidorAnormalidad, Cliente, DataBaseAlias) {
      let lnResult = 0;
  
        // Obtener los parámetros de lectura
        // const loParametroLecturaDAL = new ParametroLecturaDAL();
        // const loParametroLectura = await loParametroLecturaDAL.GetAlldt(1, DataBaseAlias);
        const loParametroLectura = await this.GetAllParametroLectura(1);


        const ID_Cambio = loParametroLectura[0].AnormalidadCambioMedidor;
  
        // Obtener los datos de la generación de factura
        // const loGeneracionFactura = await GeneracionFacturaDAL.GetRecDt(GeneracionFactura, DataBaseAlias);
        const loGeneracionFactura = await this.GetAllGeneracionFactura(GeneracionFactura);
        // loGeneracionFactura.push({
        //     FechaGeneracionLectura: '2021-10-01',
        //     Zona: 1,
        //     Ruta: 1
        // });
        
        const FechaGeneracionLectura = new Date(loGeneracionFactura[0].FechaGeneracionLectura);
  
        // Calcular las fechas de inicio y fin
        const FechaInicio = new Date(FechaGeneracionLectura);
        FechaInicio.setDate(FechaInicio.getDate() - loParametroLectura[0].DiasDeInstalacion);
  
        const FechaFin = new Date(FechaGeneracionLectura);
        FechaFin.setDate(FechaFin.getDate() - 31);
  
        // Formatear zona y ruta
        const zona = loGeneracionFactura[0].Zona < 10 ? '0' + loGeneracionFactura[0].Zona : loGeneracionFactura[0].Zona;
        const ruta = loGeneracionFactura[0].Ruta < 10 ? '0' + loGeneracionFactura[0].Ruta : loGeneracionFactura[0].Ruta;
        const ZonaRuta = zona + ruta;
  
        if (ID_Cambio > 0) {
          // Verificar cambios de medidor en el cliente
          // const loClienteMedidorDAL = new ClienteMedidorDAL();
          // const loClienteMedidor = await loClienteMedidorDAL.getAll(Cliente, DataBaseAlias);
   
          const loClienteMedidor = await this.GetAllClienteMedidor(Cliente);

          // const loClienteMedidor = [];
          // loClienteMedidor.push({
          //     NuevaInstalacion: 1
          // });


          if (ID_Cambio == MedidorAnormalidad) {
            lnResult = 0;
            this.cError = "[Valido][Cambio de Medidor]";
  
            if (loClienteMedidor.length == 0) {
              lnResult = 1;
              this.cError = "[Error][No Tiene Cambio de Medidor el Asociado]";
            }
          } else {
            if (loClienteMedidor.length > 0) {
              lnResult = 1;
              this.cError = "[Error][Tiene Cambio de Medidor el Asociado]";
            } else {
              lnResult = 2; // Ignorar en las siguientes invocaciones
            }
          }
        } else {
          lnResult = 3; // Ignorar en las siguientes invocaciones
          this.cError = "[Informativo] Cambio de Medidor no tiene Valor en ParaLect";
        }
    
      return lnResult;
    }

    async EsRegularizacionBajaTemporal(GeneracionFactura, MedidorAnormalidad, Cliente, DataBaseAlias) {
      let lnResult = 0;

      try {
        // Obtener los parámetros de lectura
        // const loParametroLecturaDAL = new ParametroLecturaDAL();
        // const loParametroLectura = await loParametroLecturaDAL.GetAlldt(1, DataBaseAlias);
        const loParametroLectura = await this.GetAllParametroLectura(1);
    
        const ID_Regula = loParametroLectura[0].AnormalidadRegularizacionBajaTemporal;

        // Obtener los datos de la generación de factura
        // const loGeneracionFactura = await GeneracionFacturaDAL.GetRecDt(GeneracionFactura, DataBaseAlias);
        const loGeneracionFactura = await this.GetAllGeneracionFactura(GeneracionFactura);
        // const loGeneracionFactura = [];
        // loGeneracionFactura.push({
        //     FechaGeneracionLectura: '2021-10-01',
        //     Zona: 1,
        //     Ruta: 1
        // });
        
        const FechaGeneracionLectura = new Date(loGeneracionFactura[0].FechaGeneracionLectura);

        // Calcular las fechas de inicio y fin
        const FechaInicio = new Date(FechaGeneracionLectura);
        FechaInicio.setDate(FechaInicio.getDate() - loParametroLectura[0].DiasDeInstalacion);

        const FechaFin = new Date(FechaGeneracionLectura);
        FechaFin.setDate(FechaFin.getDate() - 31);

        // Formatear zona y ruta
        const zona = loGeneracionFactura[0].Zona < 10 ? '0' + loGeneracionFactura[0].Zona : loGeneracionFactura[0].Zona;
        const ruta = loGeneracionFactura[0].Ruta < 10 ? '0' + loGeneracionFactura[0].Ruta : loGeneracionFactura[0].Ruta;
        const ZonaRuta = zona + ruta;

        if (ID_Regula > 0) {
          // Verificar cliente en la instalación del medidor
          // const loInstalacionMedidorDAL = new InstalacionMedidorDAL();
          // const loInstalacionMedidor = await loInstalacionMedidorDAL.obtenerCliente(Cliente, DataBaseAlias);
         
          const loInstalacionMedidor = [];
          // loInstalacionMedidor.push({
          //     NuevaInstalacion: 1
          // });


          if (ID_Regula == MedidorAnormalidad) {
            lnResult = 0;
            this.cError = "[Valido][Regularización Baja Temporal]";

            if (loInstalacionMedidor.length == 0) {
              lnResult = 1;
              this.cError = "[Error][No Tiene Regularización Baja Temporal el Asociado]";
            }
          } else {
            if (loInstalacionMedidor.length > 0) {
              lnResult = 1;
              this.cError = "[Error][Tiene Regularización Baja Temporal el Asociado]";
            } else {
              lnResult = 2; // Ignorar en las siguientes invocaciones
            }
          }
        } else {
          lnResult = 4; // Ignorar en las siguientes invocaciones
          this.cError = "[Informativo] Regularización x Baja Temporal no existe en ParaLect";
        }
      } catch (error) {
        this.cError = "Error Try/Catch";
        console.error(this.cError, error);
      }

      return lnResult;
    }


    async GetAllParametroLectura(tnParametro) {
     //m,etodo para bnucar un cliente en la tabla clientes
      try {
          const db = await getDataBase();
          const tx = db.transaction('PARAMETROLECTURA', 'readonly');
          const store = tx.objectStore('PARAMETROLECTURA');
          const loData = await store.getAll(Number(tnParametro));
          await tx.done;
          return loData;
      } catch (error) {
        console.error('Error al buscar cliente por Cliente:', error);
        return [];
      }
  
    }


    async GetAllGeneracionFactura(tnGeneracionFactura) {
      //m,etodo para bnucar un cliente en la tabla clientes
       try {
           const db = await getDataBase();
           const tx = db.transaction('GENERACIONFACTURA', 'readonly');
           const store = tx.objectStore('GENERACIONFACTURA');
           const loData = await store.getAll(Number(tnGeneracionFactura));
           await tx.done;
           return loData;
       } catch (error) {
         console.error('Error al buscar cliente por GeneracionFactura:', error);
         return [];
       }
   
     }


     
    async GetAllClienteMedidor(Cliente) {
      //m,etodo para bnucar un cliente en la tabla clientes
       try {
           const db = await getDataBase();
           const tx = db.transaction('CLIENTEMEDIDOR', 'readonly');
           const store = tx.objectStore('CLIENTEMEDIDOR');
           const index = store.index('Cliente');
           const ClienteNum = Number(Cliente);
           const loData = await index.getAll(ClienteNum);
           await tx.done;
           return loData;

      
        
       } catch (error) {
         console.error('Error al buscar cliente por ClienteMedidor:', error);
         return [];
       }
   
     }
   



}